<template>
  <div id="index" class="product-detail-container" @click="hideHref">
    <HeaderCommon></HeaderCommon>
    <div class="pc-product">
      <div class="product-banner-wrapper">
        <div class="product-banner-img" :style="{backgroundImage:'url('+detailObj.banner+')'}"></div>
        <!-- <img :src="detailObj.banner" alt="banner图" class="product-banner-img" /> -->
        <div class="enter-btn-wrapper" :class="{'en':lang=='en','kr':lang=='kr'}" @click.stop="toggleHref">
          <!-- <div class="enter-btn-text" v-text="$t('product.enter')"></div> -->
        </div>
        <div class="enter-list-container">
          <div class="enter-list">
            <a
              class="enter-list-item"
              v-for="item in detailObj.game_hrefs"
              :key="item.id"
              v-text="item.title"
              :href="item.href"
              target="_blank"
            ></a>
          </div>
        </div>
      </div>
      <div class="new-activity-container">
        <div class="product-title-wrapper">
          <div class="activity-title" v-text="$t('product.new_activity')"></div>
          <img src="../../assets/img/product/new_icon.png" class="new-icon" />
        </div>
        <div class="swiper-box">
          <div class="swiper-container new-activitiy-swiper">
            <div class="swiper-wrapper">
              <a
                :href="item.href"
                class="swiper-slide"
                v-for="item in activities"
                :key="item.id"
                :title="item.title"
                :style="'background-image:url('+item.thumbnail+')'"
              >
                <div class="activity-content">
                  <div class="activity-item-title" v-text="item.title"></div>
                  <div class="activity-item-sub-title" v-text="item.desc"></div>
                </div>
              </a>
            </div>
          </div>
          <div class="swiper-activity-pagination"></div>
          <div class="swiper-activity-next"></div>
          <div class="swiper-activity-prev"></div>
        </div>
      </div>
      <div class="necessary-advanced-container">
        <div class="necessary-title product-title-wrapper" v-text="$t('product.necessary')"></div>
        <div class="swiper-box">
          <div class="swiper-container necessary-swiper">
            <div class="swiper-wrapper">
              <a
                :href="item.href"
                class="swiper-slide"
                v-for="item in necessary"
                :key="item.id"
                :title="item.title"
                :style="'background-image:url('+item.thumbnail+')'"
              >
                <div class="necessary-content">
                  <div class="necessary-item-title" v-text="item.title"></div>
                  <div class="necessary-item-sub-title" v-text="item.desc"></div>
                  <div class="necessary-item-btn" v-text="$t('product.read_detail')"></div>
                </div>
              </a>
            </div>
          </div>
          <div class="swiper-necessary-pagination"></div>
          <div class="swiper-necessary-next"></div>
          <div class="swiper-necessary-prev"></div>
        </div>
        <div class="advanced-title product-title-wrapper" v-text="$t('product.advanced')"></div>
        <div class="advanced-container" :class="{'hasMore':advanced.length>6}">
          <ul
            class="advanced-list"
            :style="{maxHeight:!isClose?Math.ceil(advanced.length/2)*18.125+'vw':'54vw'}"
          >
            <li
              v-for="item in advanced"
              class="advanced-item"
              :key="item.id"
              :title="item.title"
              :style="'background-image:url('+item.thumbnail+')'"
            >
              <a :href="item.href" class="advanced-link">
                <div class="advanced-content">
                  <div class="advanced-item-title" v-text="item.title"></div>
                  <div class="advanced-item-sub-title" v-text="item.desc"></div>
                  <div class="advanced-item-btn" v-text="$t('product.read_detail')"></div>
                </div>
              </a>
            </li>
          </ul>
          <div class="product-show-more" @click="toggleShow" v-if="advanced.length>6">
            <i :class="isClose?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"></i>
            <span v-text="isClose?$t('product.more'):$t('product.close')"></span>
            <i :class="isClose?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="wap-product">
      <div class="p-banner-container" :style="'background-image:url('+detailObj.banner+')'">
        <div class="enter-btn-wrapper" @click.stop="showWapHrefs">
          <div class="enter-btn-text" v-text="$t('product.enter')"></div>
        </div>
        <div class="wap-hrefs-box">
          <a
            class="wap-href-item"
            v-for="item in detailObj.game_hrefs"
            :key="item.id"
            :href="item.href"
            target="_blank"
          ><span v-text="item.title" class="wap-href-text"></span></a>
        </div>
      </div>
      <div class="p-activity-container">
        <header class="p-title">
          <div v-text="$t('product.new_activity')"></div>
          <img src="../../assets/img/product/new_icon.png" class="new-activity-icon" />
        </header>
        <div class="swiper-container p-activitiy-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in activities"
              :key="item.id"
              :title="item.title"
              :style="'background-image:url('+item.thumbnail+')'"
            >
              <a :href="item.href" class="activity-link">
                <div class="p-activity-content">
                  <div class="p-activity-item-title" v-text="item.title"></div>
                  <div class="p-activity-item-sub-title" v-text="item.desc"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="p-activity-swiper-pagination swiper-pagination"></div>
      </div>
      <div class="p-beginner-container">
        <header class="p-title">
          <div v-text="$t('product.necessary')"></div>
        </header>
        <div class="swiper-container p-necessary-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in necessary"
              :key="item.id"
              :title="item.title"
              :style="'background-image:url('+item.thumbnail+')'"
            >
              <a :href="item.href" class="necessary-link">
                <div class="p-necessary-content">
                  <div class="p-necessary-item-title" v-text="item.title"></div>
                  <div class="p-necessary-item-btn" v-text="$t('product.read_detail')"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="p-necessary-swiper-pagination swiper-pagination"></div>
      </div>
      <div class="p-advanced-container">
        <header class="p-title">
          <div v-text="$t('product.advanced')"></div>
        </header>
        <ul
          class="p-advanced-list"
          :style="{maxHeight:!isClose?Math.ceil(advanced.length/2)*28.5+'vw':3*28.2+'vw'}"
        >
          <li
            v-for="item in advanced"
            class="p-advanced-item"
            :key="item.id"
            :title="item.title"
            :style="'background-image:url('+item.thumbnail+')'"
          >
            <a :href="item.href" class="p-advanced-link">
              <div class="p-advanced-content">
                <div>
                  <div class="p-advanced-item-title" v-text="item.title"></div>
                  <div class="p-advanced-item-sub-title" v-text="item.desc"></div>
                </div>
                <div class="p-advanced-item-btn" v-html="$t('product.wap_read_detail')"></div>
              </div>
            </a>
          </li>
        </ul>
        <div class="p-product-show-more" @click="toggleShow" v-if="advanced.length>6">
          <i :class="isClose?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"></i>
          <span v-text="isClose?$t('product.more'):$t('product.close')"></span>
          <i :class="isClose?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"></i>
        </div>
      </div>
      <div class="wap-community-partner">
        <div class="community-container">
          <header class="p-title">
            <div v-text="$t('product.join_us')"></div>
          </header>
          <div class="community-content">
            <div class="join-wrapper">
              <div class="join-img join-wechat" @click="showWapPop">
                <div class="join-text" v-text="$t('join.wechat')"></div>
              </div>
              <a class="join-img join-tel" :href="fixBarObj.telegram" target="_blank">
                <div class="join-text" v-text="$t('join.telegram')"></div>
              </a>
              <a class="join-img join-kakao" :href="fixBarObj.kakao" target="_blank">
                <div class="join-text" v-text="$t('join.kakao')"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fix-sidebar" :style="'background-image:url('+fixBarObj.backImage+')'" v-if="fixBarObj">
      <div class="fix-list-box">
        <div class="fix-lists">
          <div class="fix-item">
            <a :href="fixBarObj.facebook" target="_blank" rel="noopener noreferrer" class="fix-icon facebook-icon" title="facebook"></a>
          </div>
          <div class="fix-item">
            <a :href="fixBarObj.twitter" target="_blank" rel="noopener noreferrer" class="fix-icon twitter-icon" title="twitter"></a>
          </div>
          <div class="fix-item">
            <a :href="fixBarObj.medium" target="_blank" rel="noopener noreferrer" class="fix-icon medium-icon" title="medium"></a>
          </div>
          <div class="fix-item" @mouseenter="isShowQrcode=true" @mouseleave="isShowQrcode=false">
            <div class="fix-icon wechat-icon" title="wechat"></div>
            <div class="wechat-qrcode-box" :class="{'show':isShowQrcode}">
              <img :src="fixBarObj.weixin" alt="qrcode" class="wechat-qrcode-img">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gray-mask" v-if="isShowWapPop"></div>
    <div class="wechat-pop-wrapper" v-if="isShowWapPop">
      <div class="close-pop" @click="isShowWapPop = false">
      </div>
      <div class="pop-content">
        <div class="pop-title" v-text="$t('home.scan_qrcode')"></div>
        <div class="pop-qrcode" style="padding: 7vw 4vw;">
          <img :src="fixBarObj.weixinWap" alt="wechat_qrcode">
        </div>
      </div>
    </div>
    <ScrollTop></ScrollTop>
    <FooterCommon></FooterCommon>
  </div>
</template>

<script>
import global from './common/common'
import HeaderCommon from './template/HeaderCommon'
import FooterCommon from './template/FooterCommon'
import ScrollTop from './template/ScrollToTop'

import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import { getUrlParam } from '../../assets/js/common' // 获取公共方法
import { getColumnList, getGameDetail } from '../../request/api'

export default {
  data () {
    return {
      detailObj: {},
      activities: [],
      necessary: [],
      advanced: [],
      fixBarObj: {},
      isClose: true,
      id: '',
      lang: '',
      isShowHerf: false,
      isShowWapHerf: false,
      isShowQrcode: false,
      isShowWapPop: false
    }
  },
  components: {
    HeaderCommon,
    FooterCommon,
    ScrollTop
  },
  created () {
    this.id = getUrlParam('game')
    this.lang = this.$cookies.get('language') || global.initLang;
  },
  methods: {
    showWapPop () {
      this.isShowWapPop = true
    },
    toggleHref () {
      $('.enter-list-container').fadeToggle()
    },
    hideHref () {
      $('.enter-list-container').fadeOut()
      this.hideWapHref()
    },
    // 初始化滚动
    initActivitiySwiper () {
      var activitiy_swiper = new Swiper('.new-activitiy-swiper', {
        autoplay: {
          delay: 5000
        },
        loop: true,
        speed: 1000,
        observer: true,
        navigation: {
          nextEl: '.swiper-activity-next',
          prevEl: '.swiper-activity-prev'
        },
        pagination: {
          el: '.swiper-activity-pagination',
          clickable: true
        }
      })

      var wap_activitiy_swiper = new Swiper('.p-activitiy-swiper', {
        autoplay: {
          delay: 5000
        },
        loop: true,
        speed: 1000,
        slidesPerView: 'auto', // 重要 可以去swiper搜索
        centeredSlides: true, // 重要
        spaceBetween: 20,
        effect: 'left',
        observer: true,
        pagination: {
          el: '.p-activity-swiper-pagination',
          clickable: true
        }
      })
    },
    initNecessarySwiper () {
      var necessary_swiper = new Swiper('.necessary-swiper', {
        autoplay: {
          delay: 5000
        },
        loop: true,
        speed: 1000,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        navigation: {
          nextEl: '.swiper-necessary-next',
          prevEl: '.swiper-necessary-prev'
        },
        pagination: {
          el: '.swiper-necessary-pagination',
          clickable: true
        }
      })
      var wap_necessary_swiper = new Swiper('.p-necessary-swiper', {
        autoplay: {
          delay: 5000
        },
        loop: true,
        speed: 1000,
        slidesPerView: 'auto', // 重要 可以去swiper搜索
        centeredSlides: true, // 重要
        spaceBetween: 20,
        effect: 'left',
        observer: true,
        pagination: {
          el: '.p-necessary-swiper-pagination',
          clickable: true
        }
      })
    },
    toggleShow () {
      this.isClose = !this.isClose
    },
    init () {
      this.getDetail()
      this.getActivities()
      this.getTiros()
      this.getAdvanceds()
      // this.initSwiper();
    },
    getDetail () {
      var _this = this
      getGameDetail({ language: _this.lang || global.initLang, game: _this.id })
        .then(res => {
          if (res.success) {
            _this.detailObj = res.game
            _this.fixBarObj = res.gamebar
            $(document).attr('title',_this.detailObj.name)
      }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getActivities () {
      var _this = this

      getColumnList({
        language: _this.lang || global.initLang,
        columnType: 'news',
        game: _this.id
      })
        .then(res => {
          if (res.success) {
            _this.activities = res.columnList
        }
      _this.$nextTick(function () {
        _this.initActivitiySwiper()
      })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getTiros () {
      var _this = this
      getColumnList({
        language: _this.lang || global.initLang,
        columnType: 'tiro',
        game: _this.id
      })
        .then(res => {
          if (res.success) {
            _this.necessary = res.columnList
          }
      _this.$nextTick(function () {
        _this.initNecessarySwiper()
      })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAdvanceds () {
      var _this = this
      getColumnList({
        language: _this.lang || global.initLang,
        columnType: 'advanced',
        game: _this.id
      })
        .then(res => {
          if (res.success) {
            _this.advanced = res.columnList
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    showWapHrefs () {
      $('.wap-hrefs-box').fadeIn()
      $('.enter-btn-wrapper').fadeOut()
    },
    hideWapHref () {
      $('.wap-hrefs-box').fadeOut()
      $('.enter-btn-wrapper').fadeIn()
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/pc";
@import "~@/assets/scss/wap";
</style>



// WEBPACK FOOTER //
// src/components/pc/Product.vue